import React, { useState } from 'react';

import {
    useParams,
    useRouteMatch,
} from "react-router-dom";

import logoImage from '../../assets/images/sally_full_logo.svg';
import { AttributeValue, AttributeWithValue } from '../../models/Attribute';
import { Contract } from '../../models/Contract';
import { ContractLockRule, ContractLockRuleState } from '../../models/ContractLockRule';
import { ContractWarningRule, ContractWarningRuleState } from '../../models/ContractWarningRule';
import SignService from '../../services/SignService';
import { ContractStep1 } from './step1/ContractStep1';
import { ContractStep2 } from './step2/ContractStep2';
import { ContractStep3 } from './step3/ContractStep3';
import { ContractStep4 } from './step4/ContractStep4';
import { ContractStep5 } from './step5/ContractStep5';

export const ContractPage = () => {

    const {path} = useRouteMatch();

    let { token } = useParams<any>();

    const [step, setStep] = useState(0);
    const [contract, setContract] = useState<Contract|null>(null);
    const [attributes, setAttributes] = useState<AttributeWithValue[]>([]);

    const fetchContract = async () => {
        const fetchContract = await SignService.getContractData(token);
        if(fetchContract) {
            setContract(fetchContract);
            setAttributes(fetchContract.attribute_values.map((av: AttributeValue) => ({
                value: av.value,
                name: av.attribute.name,
                display_name: av.attribute.display_name,
                icon: av.attribute?.icon,
                show_on_summary: av.attribute?.show_on_summary || false
            })));
        } else {
            setStep(-1);
        }
    }

    React.useEffect(() => {
        fetchContract();
    }, []);

    const nextStep = () => {
        setStep((step < 4) ? step + 1 : 4);
    }

    const prevStep = () => {
        setStep((step > 0) ? step - 1 : 0);
    }

    return (
        <div className='h-100 min-vh-100 contract-page'>
            <div className="main-content">
                <nav className="navbar navbar-expand-md navbar-dark d-flex" id="topbar">
                    <div className="container justify-content-center">
                        <div className="navbar-brand">
                            <img src={logoImage} className="navbar-brand-img" alt="Sally" />
                            <span>Umowa z Sally</span>
                        </div>
                        <div className="w-100 text-center text-md-right text-white text-">
                            {step == 0 && <span>Witamy!</span>}
                            {step == 1 && <span>Krok 1 z 3<br />Warunki zlecenia</span>}
                            {step == 2 && <span>Krok 2 z 3<br />Twoje dane</span>}
                            {step == 3 && <span>Krok 3 z 3<br />Podgląd umowy</span>}
                            {step == 4 && <span>Podsumowanie</span>}
                        </div>
                    </div>
                </nav>
                <div className="container h-100" id="steps-container">
                    {!contract && step >= 0 && <p>Wczytuję umowę...</p>}
                    {!contract && step < 0 && <p>Umowa jest nieprawidłowa lub nie można pobrać informacji. Skontaktuj się z obsługą.</p>}
                    {contract && <>
                    <ContractStep1 showStep={step == 0} nextStep={nextStep} contract={contract} />
                    <ContractStep2 showStep={step == 1} nextStep={nextStep} prevStep={prevStep} contract={contract} attributes={attributes} />
                    <ContractStep3 showStep={step == 2} nextStep={nextStep} prevStep={prevStep} contract={contract} token={token} />
                    <ContractStep4 showStep={step == 3} nextStep={nextStep} prevStep={prevStep} contract={contract} token={token} />
                    <ContractStep5 showStep={step == 4} nextStep={nextStep} contract={contract} attributes={attributes} />
                    </>}
                </div>
            </div>
            <footer className="footer py-5">
                <div className="container text-center text-md-left">
                    <p>© {(new Date().getFullYear())} Sally</p>
                </div>
            </footer>
        </div>
    )
}